export var MapServiceEvent = ['mapload', 'mapchange', 'mapAfterFrameChange'];
//# sourceMappingURL=IMapService.js.map